import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Copy } from "lucide-react";

function Shell({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="min-h-full bg-background pb-16">
      <div className="border-b border-border/70 bg-white/90 backdrop-blur">
        <div className="mx-auto max-w-[720px] px-6 py-6 lg:px-10">
          <Link to="/innovation/records" className="text-sm font-medium text-primary hover:underline">
            ← 评价记录
          </Link>
          <h1 className="mt-4 text-2xl font-semibold tracking-tight text-foreground">{title}</h1>
        </div>
      </div>
      <div className="mx-auto max-w-[720px] px-6 py-8 lg:px-10">{children}</div>
    </div>
  );
}

export function InnovationShareLink() {
  const demoUrl = `${typeof window !== "undefined" ? window.location.origin : ""}/innovation/records/demo-share`;
  return (
    <Shell title="分享链接">
      <div className="rounded-2xl border border-white/90 bg-white p-6 shadow-sm">
        <p className="text-sm text-muted-foreground">以下为演示链接；接入后端后可替换为带时效签名与权限校验的 URL。</p>
        <div className="mt-4 flex flex-wrap items-center gap-2 rounded-xl border border-border bg-muted/20 px-4 py-3 font-mono text-xs text-foreground">{demoUrl}</div>
        <button
          type="button"
          className="mt-4 inline-flex items-center gap-2 rounded-xl bg-primary px-4 py-2.5 text-sm font-medium text-primary-foreground hover:opacity-90"
          onClick={() => void navigator.clipboard.writeText(demoUrl)}
        >
          <Copy className="h-4 w-4" />
          复制链接
        </button>
      </div>
    </Shell>
  );
}

export function InnovationShareKnowledge() {
  return (
    <Shell title="分享到知识库">
      <div className="rounded-2xl border border-white/90 bg-white p-6 shadow-sm">
        <p className="text-sm text-muted-foreground">
          将把本轮评审摘要与卡片快照归档至所选知识库（复用「知识」模块权限模型）。以下为占位向导。
        </p>
        <button type="button" className="mt-6 w-full rounded-xl bg-primary py-3 text-sm font-medium text-primary-foreground hover:opacity-90">
          选择知识库…
        </button>
      </div>
    </Shell>
  );
}
